const U = (id, w = 1600) => `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;
const P = (id, w = 1600) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const site = {
  name: "Collanmore Island Lodge",
  phoneDisplay: "+353 86 251 8252",
  phoneHref: "tel:+353862518252",
  whatsapp: "https://wa.me/353862518252",
  email: "ciaran@collanmoreislandlodge.com",
  address: "Collanmore Island, Clew Bay, Westport, County Mayo, Ireland",
};

export const nav = [
  { label: "The Lodge", to: "/private-island-accommodation-westport/" },
  {
    label: "Hen & Stag Parties",
    to: "/hen-parties-westport/",
    children: [
      { label: "Hen Parties", to: "/hen-parties-westport/" },
      { label: "Stag Parties", to: "/stag-parties-westport/" },
    ],
  },
  { label: "Traitors Island", to: "/traitors-island-experience/" },
  {
    label: "Activities",
    to: "/adventure-activities-westport/",
    children: [
      { label: "Sea Kayaking", to: "/adventure-activities-westport/#activity-sea-kayaking" },
      { label: "Stand-Up Paddleboarding", to: "/adventure-activities-westport/#activity-sup-clew-bay" },
      { label: "Sumo Suits", to: "/adventure-activities-westport/#activity-sumo-suits" },
      { label: "Sea Safari (RIB)", to: "/adventure-activities-westport/#activity-sea-safari" },
      { label: "Beach Sauna", to: "/beach-sauna-westport/#activity-beach-sauna" },
      { label: "Outdoor Hot Tub", to: "/beach-sauna-westport/#activity-hot-tub" },
    ],
  },
  { label: "Gift Vouchers", to: "/gift-vouchers/" },
  { label: "Journal", to: "/journal/" },
  { label: "Gallery", to: "/gallery/" },
  { label: "Contact", to: "/contact/" },
];

export const activities = [
  {
    id: "beach-sauna",
    name: "Beach Sauna & Sea Swim",
    blurb: "Wood-fired barrel sauna on the shore with a bracing Clew Bay dip — the wildest wake-up in Mayo.",
    price: 35,
    deposit: 15,
    mode: "deposit",
    active: true,
  },
  {
    id: "sea-kayaking",
    name: "Sea Kayaking",
    blurb: "Paddle beneath the lodge and around the island's hidden coves with our partner guides.",
    price: 45,
    deposit: 15,
    mode: "deposit",
    active: true,
  },
  {
    id: "sailing-clew-bay",
    name: "Sailing Clew Bay",
    blurb: "Skippered sailing among the bay's hundred islands and Drumlin backs — no experience needed.",
    price: 55,
    deposit: 20,
    mode: "deposit",
    active: true,
  },
  {
    id: "sup-clew-bay",
    name: "Stand-Up Paddleboarding",
    blurb: "Glide across glassy morning water on a paddleboard, guided all the way.",
    price: 40,
    deposit: 15,
    mode: "deposit",
    active: true,
  },
  {
    id: "archery-lawn",
    name: "Archery on the Lawn",
    blurb: "Longbow sessions for first-timers and budding Robin Hoods, right on the front lawn.",
    price: 30,
    deposit: 12,
    mode: "deposit",
    active: true,
  },
  {
    id: "hot-tub",
    name: "Outdoor Hot Tub",
    blurb: "Bubbles, blankets and Clew Bay views on the lodge deck — hot-tub heaven after a day of adventure.",
    price: 30,
    deposit: 15,
    mode: "deposit",
    active: true,
  },
  {
    id: "sumo-suits",
    name: "Sumo Suits",
    blurb: "Giant sumo suits on the lawn — the funniest five minutes of any island weekend.",
    price: 25,
    deposit: 10,
    mode: "deposit",
    active: true,
  },
  {
    id: "sea-safari",
    name: "Sea Safari (RIB)",
    blurb: "Hold on tight — a high-speed RIB safari through the islands and sea caves of Clew Bay.",
    price: 50,
    deposit: 20,
    mode: "deposit",
    active: true,
  },
];

export const footerNav = [
  { label: "Home", to: "/" },
  { label: "The Island Lodge", to: "/private-island-accommodation-westport/" },
  { label: "Hen Parties", to: "/hen-parties-westport/" },
  { label: "Stag Parties", to: "/stag-parties-westport/" },
  { label: "Birthdays & Celebrations", to: "/private-island-celebrations/" },
  { label: "Corporate Retreats", to: "/corporate-retreats-mayo/" },
  { label: "Traitors Island", to: "/traitors-island-experience/" },
  { label: "Adventure Activities", to: "/adventure-activities-westport/" },
  { label: "Beach Sauna & Wellness", to: "/beach-sauna-westport/" },
  { label: "Weddings & Private Events", to: "/private-island-weddings-mayo/" },
  { label: "Packages & Prices", to: "/private-island-packages-prices/" },
  { label: "Gift Vouchers", to: "/gift-vouchers/" },
  { label: "Gallery", to: "/gallery/" },
  { label: "Island Journal", to: "/journal/" },
  { label: "Availability", to: "/availability/" },
  { label: "Build Your Island Weekend", to: "/build-your-island-weekend/" },
  { label: "About the Lodge", to: "/about-collanmore-island-lodge/" },
  { label: "FAQs", to: "/frequently-asked-questions/" },
  { label: "Contact & Booking", to: "/contact/" },
];

export const hero = {
  eyebrow: "Clew Bay · Wild Atlantic Way · Ireland",
  titleLines: [
    { text: "YOUR OWN", italic: false },
    { text: "PRIVATE ISLAND", italic: true },
    { text: "ESCAPE", italic: false },
  ],
  tagline: "Exclusive Island Accommodation, Adventure & Unforgettable Experiences in Clew Bay, Westport, County Mayo.",
  body: "Imagine escaping the mainland with your favourite people and arriving by high-speed boat at your own exclusive island lodge. Sleeping up to 22 guests, Collanmore Island Lodge brings together spectacular Atlantic scenery, private bars, a beach sauna, hot tub and unforgettable outdoor adventures.",
  image: "/images/real/hero-bay.jpg",
  imageAlt: "Evening light over Collanmore Island and the islands of Clew Bay",
  cta1: { label: "Plan Your Island Escape", to: "/contact/" },
  cta2: { label: "Explore the Lodge", to: "/private-island-accommodation-westport/" },
};

export const marquee = ["ONE ISLAND", "ONE GROUP", "EXCLUSIVELY YOURS"];

export const island = {
  eyebrow: "The Island",
  heading: "An entire island, kept just for you",
  body1: "Collanmore Island Lodge is an exclusive-use private island accommodation and adventure destination located just off Westport, County Mayo. The lodge accommodates up to 22 overnight guests and is available for private group bookings — you and your guests have the entire island to yourselves.",
  body2: "Guests enjoy exclusive use of the lodge and its facilities, creating an extraordinary setting for celebrations, family gatherings, corporate retreats, hen and stag weekends and special occasions — with breathtaking coastal scenery in every direction.",
  stats: [
    { value: "22", label: "Overnight Guests" },
    { value: "1", label: "Group at a Time" },
    { value: "100%", label: "Exclusive Use" },
  ],
  mainImage: "/images/real/kayak-aerial.jpg",
  mainAlt: "Kayakers paddling the clear sheltered waters of Clew Bay beside the island shore",
  overlapImage: "/images/real/island-lighthouse.jpg",
  overlapAlt: "The island lighthouse at golden hour, Clew Bay beyond",
};

export const accommodation = {
  eyebrow: "Accommodation",
  heading: "The Lodge",
  lead: "An exclusive island lodge set amidst landscaped gardens, within walking distance of your own white sandy beach — with spectacular views across Clew Bay.",
  features: [
    "Exclusive-use island lodge",
    "Overnight accommodation for up to 22 guests",
    "Comfortable group bedrooms",
    "Private bar and entertainment facilities",
    "Spacious communal areas",
    "Outdoor hot tub",
    "Spectacular views across Clew Bay",
  ],
  mainImage: "/images/real/lodge-living.jpg",
  mainAlt: "The spacious communal living and dining area inside Collanmore Island Lodge",
  strip: [
    { src: "/images/real/lodge-deck-night.jpg", alt: "The lodge deck and outdoor seating lit by lanterns after dark" },
    { src: "/images/real/lodge-bar.jpg", alt: "The private bar at Collanmore Island Lodge" },
    { src: "/images/real/lodge-deck-day.jpg", alt: "The sun deck with picnic tables overlooking the bay" },
    { src: "/images/real/hottub-bubbles.webp", alt: "The outdoor hot tub bubbling away beside the deck, with Clew Bay and the picnic tables beyond" },
  ],
};

export const experiences = [
  {
    title: "Kayaking & Stand-Up Paddleboarding",
    copy: "Explore the sheltered waters and spectacular scenery of Clew Bay.",
    src: "/images/real/kayak-pair.jpg",
    alt: "Guests cheering on a kayak during a paddling adventure in Clew Bay",
    to: "/adventure-activities-westport/",
    pos: "center 30%",
    span: "lg:col-span-7",
  },
  {
    title: "Luxury Beach Sauna",
    copy: "Relax in our beautiful wood-burning beach sauna overlooking the Atlantic coastline.",
    src: "/images/real/sauna-group.webp",
    alt: "A group enjoying the wood-burning beach sauna on Collanmore Island, with the sea view through the window",
    to: "/beach-sauna-westport/",
    span: "lg:col-span-5",
  },
  {
    title: "Outdoor Hot Tub",
    copy: "Unwind and enjoy the unique atmosphere of your own private island.",
    src: "/images/real/hottub-bubbles.webp",
    alt: "The outdoor hot tub bubbling away beside the deck, with Clew Bay and the picnic tables beyond",
    to: "/beach-sauna-westport/",
    span: "lg:col-span-5",
  },
  {
    title: "High-Speed RIB Adventures",
    copy: "Experience exciting boat journeys and spectacular coastal scenery.",
    src: "/images/real/rib-wake.jpg",
    alt: "Aerial view of our RIB carving through the islands of Clew Bay",
    to: "/adventure-activities-westport/",
    span: "lg:col-span-7",
  },
  {
    title: "Private Island Celebrations",
    copy: "Unforgettable birthdays, hen and stag parties, family reunions and special occasions.",
    src: "/images/real/bar-pints.webp",
    alt: "Pints of Guinness lined up on the bar at Tom's Bar while a celebration group gathers behind",
    to: "/private-island-celebrations/",
    span: "lg:col-span-4",
  },
  {
    title: "Corporate Retreats",
    copy: "A unique environment for team building, company gatherings and corporate events.",
    src: U("photo-1699730148132-1409a3728479", 1200),
    alt: "Colleagues gathered around a table during a corporate retreat",
    to: "/corporate-retreats-mayo/",
    span: "lg:col-span-4",
  },
  {
    title: "Traitors Island",
    copy: "Our immersive mystery and challenge weekends, inspired by intrigue, strategy, teamwork and entertainment.",
    src: "/images/real/traitors-poster-midnight.webp",
    alt: "Traitors Island poster — an immersive island mystery weekend at Collanmore Island Lodge, Clew Bay, Westport",
    span: "lg:col-span-4",
    noOverlay: true,
    to: "/traitors-island-experience/",
  },
  {
    title: "Intimate Weddings",
    copy: "A unique private island setting for romantic celebrations and exclusive wedding experiences.",
    src: "/images/real/island-wedding-aerial.jpg",
    alt: "Aerial view of a wedding gathering on Collanmore Island with Clew Bay and the mountain beyond",
    to: "/private-island-weddings-mayo/",
    span: "lg:col-span-6",
  },
  {
    title: "Chinese Banquet",
    copy: "Order in the feast — your Chinese banquet is delivered straight to the lodge and served long-table for the whole group.",
    src: U("photo-1559667709-eabb5b50117a", 1400),
    alt: "A Chinese banquet of dim sum and sharing dishes laid out along the lodge table",
    to: "/private-island-celebrations/",
    span: "lg:col-span-6",
  },
  {
    title: "Two-Man Band",
    copy: "Live music on request — a two-man band plays your evening at the lodge, from easy melodies by the fire to a full session at the bar.",
    src: "/images/real/two-man-band.jpg",
    alt: "The two-man band — guitar and accordion at sunset above the bay",
    to: "/private-island-celebrations/",
    pos: "center 38%",
    span: "lg:col-span-12",
  },
];

export const celebrations = [
  {
    number: "01",
    title: "Private Island Celebrations",
    copy: "Unforgettable birthdays, hen and stag parties, family reunions and special occasions — with the whole island, the private bar and the hot tub reserved for your group alone.",
    src: "/images/real/hen-party.jpg",
    alt: "A hen party waving hello from the boat as they arrive at the island",
  },
  {
    number: "02",
    title: "Corporate Retreats",
    copy: "A unique environment for team building, company gatherings and corporate events. Trade the boardroom for sea air, open fires and adventures your team will talk about for years.",
    src: U("photo-1699730148132-1409a3728479", 1400),
    alt: "Team members sharing a meal together on retreat",
  },
  {
    number: "03",
    title: "Intimate Weddings",
    copy: "A unique private island setting for romantic celebrations and exclusive wedding experiences, framed by the waters of Clew Bay and the golden light of the Atlantic.",
    src: "/images/real/wedding-couple.jpg",
    alt: "A newlywed couple kissing on the pontoon beside the Collanmore Island Lodge RIB",
  },
];

export const traitors = {
  eyebrow: "Traitors Island",
  heading: "Trust no one.",
  copy: "Our immersive mystery and challenge weekends, inspired by intrigue, strategy, teamwork and entertainment. Gather your allies — and watch your back.",
  cta: "Enter the Game",
  poster: "/images/real/traitors-poster-mystery-begins.webp",
  posterAlt: "Traitors Island poster — can you be trusted? An immersive island mystery weekend at Collanmore Island Lodge, Clew Bay, Westport, County Mayo",
};

export const social = {
  instagram: "https://www.instagram.com/collanmoreislandlodge/",
  facebook: "https://www.facebook.com/Collanmoreisland/",
};

export const partner = {
  eyebrow: "Our Activity Partner",
  heading: "The Adventure Islands",
  copy: "Collanmore Island Lodge works with The Adventure Islands, our activity partner in Westport. Their team delivers guided kayaking, stand-up paddleboarding and sea safari adventures on the waters of Clew Bay and along the Wild Atlantic Way coastline.",
  activities: ["Guided Kayaking", "Stand-Up Paddleboarding", "Sea Safaris"],
  website: "https://www.theadventureislands.com",
  websiteLabel: "Visit theadventureislands.com",
};

export const packages = {
  heroEyebrow: "Packages & Prices",
  heroH1: "Your Own Private Island Awaits",
  heroParas: [
    "Escape to Collanmore Island Lodge, an exclusive private island retreat in the heart of Clew Bay, Westport, County Mayo.",
    "Enjoy complete privacy, breathtaking scenery and unforgettable experiences with your favourite people.",
  ],
  pkgEyebrow: "Package 1 — Exclusive Private Island Weekend",
  pkgH2: "Your Own Private Island Awaits",
  pkgPrice: "€3,300",
  pkgPriceNote: "Two nights",
  pkgIncludes: [
    "Two nights' exclusive use of Collanmore Island Lodge",
    "Accommodation for up to 22 guests",
    "Exclusive use of the private bar and entertainment areas",
    "Access to the outdoor hot tub",
    "Spectacular island surroundings and beautiful sea views",
  ],
  pkg2Eyebrow: "Package 2 — Hen & Stag Island Celebrations",
  pkg2H2: "The Ultimate Private Island Party",
  pkg2Price: "€4,999",
  pkg2PriceNote: "Two nights' accommodation — includes beach sauna, kayaking & stand-up paddleboarding, Chinese banquet, two-man band (2 hours) and high-speed return ferry",
  pkg2Badge: "All-inclusive",
  pkg2Note: "Everything included: accommodation, ferry transfers, activities, banquet and entertainment — no hidden extras.",
  pkg2Includes: [
    "Two nights' exclusive use of Collanmore Island Lodge",
    "Accommodation for up to 22 guests",
    "Private bar and entertainment areas",
    "Outdoor hot tub",
    "Wood-burning beach sauna",
    "Kayaking and stand-up paddleboarding",
    "Chinese banquet — side/starter and main course",
    "Live two-man band — two hours of entertainment",
    "High-speed return ferry transfers",
  ],
  pkg2Cta: "Enquire About Your Hen or Stag Weekend",
  pkg3Title: "Traitors Island",
  pkg3Price: "€3,800",
  pkg3PriceNote: "Selected two-night weekends",
  pkg3Copy: "An immersive mystery experience with strategy, alliances, challenges and deception, including exclusive lodge accommodation for up to 22 guests and an organised mystery programme. Exact dates and programme inclusions to be confirmed before publication. No affiliation with the television programme The Traitors is claimed.",
  pkg4Title: "Corporate Island Retreats",
  pkg4Price: "Price on enquiry",
  pkg4PriceNote: "",
  pkg4Copy: "Tailored corporate retreats, team building, leadership gatherings and staff celebrations. Exclusive island accommodation and optional kayaking, paddleboarding, beach sauna, dining and entertainment. Request a bespoke proposal.",
  pkg4Cta: "Request a Quote",
  pkg5Title: "Private Island Weddings",
  pkg5Price: "From €10,800",
  pkg5PriceNote: "Indicative base",
  pkg5Copy: "Venue hire €7,500 plus two-night lodge accommodation €3,300. Additional indicative charges: cleaning €400, gas €200, refundable damage deposit €1,000; catering, ferry and other services quoted separately. Final scope, capacity and pricing require confirmation in the wedding quotation.",
  pkg6Title: "Birthdays & Private Celebrations",
  pkg6Price: "From €3,300",
  pkg6PriceNote: "Two nights",
  pkg6Copy: "Two nights of exclusive island lodge accommodation for up to 22 guests. Ideal for milestone birthdays, anniversaries, family reunions and private celebrations, with optional adventures, dining and live music.",
  ferryTitle: "Essential Ferry Transfers",
  ferryPrice: "€20 per person return",
  ferryNote: "Return high-speed RIB transfer from Rosmoney Pier: €20 per person aged 16 and over. Essential and charged separately from accommodation — except Package 2, where return ferry transfers are fully included. Confirm arrangements for younger guests at enquiry.",
  advTitle: "Special Island Adventure Package",
  advBadge: "Most popular",
  advPrice: "€50",
  advUnit: "per person",
  advNormal: "€85",
  advSaving: "Save €35 per person",
  advIncludes: ["Kayaking", "Stand-up paddleboarding", "Luxury wood-burning beach sauna"],
  extrasHeading: "Other Optional Extras",
  extras: [
    { label: "Kayaking & stand-up paddleboarding", price: "€65 per person" },
    { label: "Island adventure package — kayaking, paddleboarding & beach sauna (save €35)", price: "€50 per person" },
    { label: "Beach sauna only", price: "€20 per person" },
    { label: "Chinese banquet — starter/side and main course", price: "€18 per person" },
    { label: "Live two-person band — two hours of entertainment", price: "€500 per group" },
  ],
  extrasNote: "Water activities are seasonal and weather dependent. The €50 combination is a special package offer; confirm availability before booking.",
  bookingTitle: "Booking & Payment",
  bookingNotes: [
    "Booking deposit: €1,000",
    "Balance due 16 weeks before arrival, subject to agreed booking terms.",
    "All prices in euro and subject to availability and confirmation.",
  ],
  ctaHeading: "Book Your Private Island Escape",
  ctaLead: "Whether it's a birthday celebration, hen or stag weekend, family gathering or simply an unforgettable weekend with friends — one island, one group, exclusively yours.",
  ctaLabel: "Enquire Now",
};

export const galleryCategories = [
  "The Island & Clew Bay",
  "The Lodge & Accommodation",
  "Beach Sauna & Hot Tub",
  "Island Adventures",
  "Celebrations & Events",
  "Traitors Island",
];

export const galleryPage = {
  heroEyebrow: "A Glimpse of Island Life",
  heroH1: "Discover the Magic of Collanmore Island",
  heroParas: [
    "From breathtaking views across Clew Bay to unforgettable celebrations, relaxing sauna sessions and exciting water adventures, every visit to Collanmore Island Lodge creates memories to treasure.",
    "Explore our island through photographs and videos.",
  ],
  ctaHeading: "Experience the Island",
  ctaLead: "Every photograph here was taken on Collanmore. Imagine your own group in the next ones — one island, one group, exclusively yours.",
  ctaLabel: "Enquire Now",
  items: [
    { src: "/images/real/clewbay-aerial.jpg", alt: "Aerial view of Collanmore Island and the islands of Clew Bay, County Mayo", category: "The Island & Clew Bay" },
    { src: "/images/real/clewbay-drumlins.jpg", alt: "The drumlins and islands of Clew Bay from the air", category: "The Island & Clew Bay" },
    { src: "/images/real/clewbay-sunset.jpg", alt: "Sunset across Clew Bay, County Mayo", category: "The Island & Clew Bay" },
    { src: "/images/real/clewbay-sailboats.jpg", alt: "Sailboats on the waters of Clew Bay at dusk", category: "The Island & Clew Bay" },
    { src: "/images/real/hero-bay.jpg", alt: "Panoramic view over Clew Bay from Collanmore Island", category: "The Island & Clew Bay" },
    { src: "/images/real/sailing-ship.jpg", alt: "A tall ship sailing past Collanmore Island in Clew Bay", category: "The Island & Clew Bay" },
    { src: "/images/real/dji-0026.jpg", alt: "Drone photograph of Collanmore Island and the Mayo coastline", category: "The Island & Clew Bay" },
    { src: "/images/real/lodge-living.jpg", alt: "The communal living room of Collanmore Island Lodge", category: "The Lodge & Accommodation" },
    { src: "/images/real/lodge-bar.jpg", alt: "The private bar at Collanmore Island Lodge", category: "The Lodge & Accommodation" },
    { src: "/images/real/lodge-deck-day.jpg", alt: "The lodge deck and outdoor seating by day", category: "The Lodge & Accommodation" },
    { src: "/images/real/lodge-deck-night.jpg", alt: "The lodge deck and outdoor seating lit by lanterns after dark", category: "The Lodge & Accommodation" },
    { src: "/images/real/bunk-room.jpg", alt: "The group bunk room — timber bunks and garden views", category: "The Lodge & Accommodation" },
    { src: "/images/real/bar-pints.webp", alt: "Pints of Guinness lined up on the bar at Tom's Bar", category: "The Lodge & Accommodation" },
    { src: "/videos/lodge-tour.mp4", alt: "Video tour inside Collanmore Island Lodge", category: "The Lodge & Accommodation", type: "video" },
    { src: "/images/real/sauna-group.webp", alt: "Guests enjoying the wood-burning beach sauna", category: "Beach Sauna & Hot Tub" },
    { src: "/images/real/hottub-bubbles.webp", alt: "The outdoor hot tub bubbling beside the deck, with Clew Bay beyond", category: "Beach Sauna & Hot Tub" },
    { src: "/images/real/kayak-aerial.jpg", alt: "Aerial view of kayakers exploring the Clew Bay coastline", category: "Island Adventures" },
    { src: "/images/real/kayak-pair.jpg", alt: "Two kayakers paddling the sheltered waters of Clew Bay", category: "Island Adventures" },
    { src: "/images/real/rib-jetty.jpg", alt: "The high-speed RIB moored at the island jetty", category: "Island Adventures" },
    { src: "/images/real/rib-spin.jpg", alt: "The RIB spinning a full donut beside the pontoon", category: "Island Adventures" },
    { src: "/images/real/rib-wake.jpg", alt: "The wake of the high-speed RIB crossing Clew Bay", category: "Island Adventures" },
    { src: "/images/real/rib-sunset-guests.jpg", alt: "Guests on the RIB at sunset in Clew Bay", category: "Island Adventures" },
    { src: "/images/real/hen-party.jpg", alt: "A hen party celebrating on Collanmore Island", category: "Celebrations & Events" },
    { src: "/images/real/hen-party-lodge.jpg", alt: "A hen party dining together at the lodge", category: "Celebrations & Events" },
    { src: "/images/real/sumo-lawn.jpg", alt: "Sumo suit wrestling on the lodge lawn during a group weekend", category: "Celebrations & Events" },
    { src: "/images/real/wedding-couple.jpg", alt: "A newlywed couple beside the RIB on the island pontoon", category: "Celebrations & Events" },
    { src: "/images/real/island-wedding-aerial.jpg", alt: "Aerial view of an intimate island wedding ceremony", category: "Celebrations & Events" },
    { src: "/images/real/two-man-band.jpg", alt: "The live two-man band playing at the lodge", category: "Celebrations & Events" },
    { src: "/images/real/traitors-poster-midnight.webp", alt: "Traitors Island poster — an immersive island mystery experience", category: "Traitors Island" },
    { src: "/images/real/traitors-island-poster.webp", alt: "Traitors Island themed poster over the lodge island at sunset", category: "Traitors Island" },
  ],
};

export const about = {
  heroEyebrow: "More Than a Destination. An Island Experience.",
  heroH1: "Welcome to Collanmore Island Lodge",
  heroParas: [
    "Nestled in the spectacular waters of Clew Bay, just off Westport in County Mayo, Collanmore Island Lodge offers something truly extraordinary — the opportunity to escape to your own private island.",
    "Surrounded by the natural beauty of Ireland's Wild Atlantic Way, our island lodge combines privacy, adventure, relaxation and unforgettable experiences.",
    "Unlike a traditional hotel or holiday resort, Collanmore Island Lodge is available for exclusive private hire. One Island. One Group. Exclusively Yours.",
  ],
  sections: [
    {
      eyebrow: "An Extraordinary Setting",
      h2: "Arrive by Boat, Leave the Mainland Behind",
      paras: [
        "Imagine arriving by high-speed boat from Rosmoney Pier, leaving the mainland behind and discovering a peaceful island surrounded by breathtaking Atlantic scenery.",
        "With views across Clew Bay and the mountains of County Mayo, Collanmore offers an unforgettable backdrop for special occasions.",
      ],
      img: "/images/real/clewbay-aerial.jpg",
      alt: "Aerial view of Collanmore Island in the spectacular waters of Clew Bay",
    },
    {
      eyebrow: "Your Own Private Island Lodge",
      h2: "Exclusive Use for Up to 22 Guests",
      paras: [
        "Our exclusive-use accommodation welcomes up to 22 overnight guests.",
        "Whether you're celebrating a milestone birthday, arranging a hen or stag weekend, planning a family gathering or bringing colleagues together for a corporate retreat, our lodge provides a unique setting.",
        "Guests can enjoy our private bar, communal entertainment spaces and outdoor hot tub, with optional activities and experiences available.",
      ],
      img: "/images/real/lodge-living.jpg",
      alt: "The communal living room of Collanmore Island Lodge",
    },
    {
      eyebrow: "Adventure Meets Relaxation",
      h2: "Explore, Unwind, Repeat",
      paras: [
        "Collanmore Island Lodge is much more than somewhere to stay.",
        "Explore the waters of Clew Bay by kayak or stand-up paddleboard. Relax in our wood-burning beach sauna overlooking the sea.",
        "Enjoy the outdoor hot tub, take in the magnificent scenery or arrange a memorable evening with a Chinese banquet and live entertainment. Our island experiences can be tailored to suit your group.",
      ],
      img: "/images/real/kayak-aerial.jpg",
      alt: "Kayakers exploring the waters of Clew Bay from above",
    },
    {
      eyebrow: "Celebrations Worth Remembering",
      h2: "Every Occasion, Extraordinary",
      paras: [
        "From birthdays and anniversaries to hen and stag parties, weddings and corporate gatherings, Collanmore Island Lodge offers a setting that makes every occasion special.",
        "We also offer our immersive Traitors Island mystery experience on selected dates.",
      ],
      img: "/images/real/sumo-lawn.jpg",
      alt: "Sumo suit fun on the lodge lawn during a group celebration",
    },
  ],
  storyEyebrow: "Our Story",
  storyH2: "A Reputation Built on Memorable Group Experiences",
  storyParas: [
    "Collanmore Island Lodge has welcomed guests to its island setting for many years, developing a reputation for memorable group experiences, adventure and hospitality.",
    "Our aim is simple: to give every group the opportunity to enjoy something truly unique. A private island, shared with the people who matter most.",
  ],
  ctaEyebrow: "Discover Collanmore",
  ctaH2: "Your Island Experience Begins Here",
  ctaParas: [
    "Whether you're looking for adventure, relaxation, celebration or simply somewhere completely different, your island experience begins here.",
  ],
  ctaLabel: "Plan Your Private Island Escape",
};

export const faqs = {
  heroEyebrow: "Everything You Need to Know",
  heroH1: "Frequently Asked Questions",
  heroParas: [
    "Planning your island escape? Here are the answers to the questions our guests ask most. For anything else, just send us an enquiry — we're happy to help.",
  ],
  items: [
    { q: "Where is Collanmore Island Lodge?", a: "Collanmore Island Lodge is situated on Collanmore Island in Clew Bay, just off Westport, County Mayo, Ireland. Guests depart from Rosmoney Pier for their boat transfer to the island." },
    { q: "How do we get to the island?", a: "Guests travel by high-speed RIB boat from Rosmoney Pier. Return ferry transfers are arranged as part of the booking process." },
    { q: "How much are return ferry transfers?", a: "Return ferry transfers cost €20 per person for guests aged 16 and over. Ferry transfers are essential and charged separately from accommodation unless explicitly included in a particular package." },
    { q: "How many guests can stay overnight?", a: "Collanmore Island Lodge accommodates up to 22 overnight guests." },
    { q: "Do we have exclusive use of the lodge?", a: "Yes. Our accommodation packages provide exclusive use of the island lodge for your group. You will not be sharing the lodge with another booking." },
    { q: "How much does it cost to book the island?", a: "Our standard two-night exclusive island accommodation package starts from €3,300. We also offer specialised celebration, Traitors Island, corporate and wedding packages. Please visit our Packages & Prices page for details." },
    { q: "How much is the booking deposit?", a: "The standard booking deposit is €1,000. The remaining balance is normally payable 16 weeks before arrival, subject to the agreed booking terms." },
    { q: "What activities are available?", a: "Activities include kayaking, stand-up paddleboarding, beach sauna sessions and other island experiences. Activities are seasonal, subject to weather conditions and must be arranged in advance." },
    { q: "How much do the activities cost?", a: "Kayaking and stand-up paddleboarding normally cost €65 per person. Our special combined package of kayaking, paddleboarding and beach sauna costs €50 per person when offered. The beach sauna normally costs €20 per person when booked separately." },
    { q: "Is there a sauna and hot tub?", a: "Yes. Collanmore Island Lodge has a wood-burning beach sauna and an outdoor hot tub. The sauna can be booked as an optional experience. Hot tub access is subject to the agreed accommodation package." },
    { q: "Can we arrange food?", a: "Yes. A Chinese banquet is available for €18 per person, including a side/starter and main course. Please arrange catering in advance." },
    { q: "Can we arrange live entertainment?", a: "Yes. A live two-person band can be arranged for approximately two hours at €500 per group, subject to availability." },
    { q: "Can we bring our own food and drinks?", a: "Groups can discuss self-catering and drink arrangements when booking. Glass beer bottles are not permitted. Please confirm all bar and beverage arrangements in advance." },
    { q: "Is Collanmore suitable for hen and stag weekends?", a: "Absolutely. Our exclusive island lodge is particularly suited to private group celebrations, with accommodation, adventure activities, sauna, hot tub, dining and entertainment options." },
    { q: "Can we book for corporate retreats?", a: "Yes. We welcome corporate groups for retreats, team-building experiences, celebrations and private company events." },
    { q: "Can we have a wedding on the island?", a: "Yes. We can discuss intimate island wedding ceremonies and private celebrations, with arrangements and prices tailored to each event." },
    { q: "What is Traitors Island?", a: "Traitors Island is our immersive mystery experience combining strategy, intrigue, alliances, challenges and entertainment in a unique private island setting. It is available on selected dates and must be booked in advance." },
    { q: "Are water activities available all year?", a: "No. Water activities are seasonal and weather-dependent. They may be unavailable during winter months." },
    { q: "What happens if the weather is bad?", a: "Boat transfers and water activities depend on safe weather and sea conditions. Safety always comes first. Alternative arrangements or changes may be necessary, subject to the agreed booking terms." },
    { q: "How do I check availability?", a: "Complete the website enquiry form with your preferred dates, number of guests and type of occasion. Our team will respond with availability and package information." },
  ],
  ctaHeading: "Still Have a Question?",
  ctaLead: "Check availability for your dates — our team will respond with availability and package information.",
  ctaLabel: "Check Availability",
};

export const instagramTeasers = [
  { src: "/images/real/clewbay-aerial.jpg", alt: "Aerial view of the islands of Clew Bay with the Mayo mountains beyond" },
  { src: "/images/real/rib-spin.jpg", alt: "Our RIB spinning a full donut beside the pontoon" },
  { src: "/images/real/sauna-group.webp", alt: "Guests enjoying the wood-burning beach sauna" },
  { src: "/images/real/hottub-bubbles.webp", alt: "The outdoor hot tub bubbling beside the deck" },
  { src: "/images/real/lodge-deck-night.jpg", alt: "The lodge deck and outdoor seating lit by lanterns after dark" },
  { src: "/images/real/island-sunset.jpg", alt: "The sun setting behind the mountains across Clew Bay" },
];

export const gallery = [
  { src: "/images/real/clewbay-aerial.jpg", alt: "Aerial view of the islands of Clew Bay with the Mayo mountains beyond", span: "col-span-2 row-span-2" },
  { src: "/images/real/rib-spin.jpg", alt: "Our RIB spinning a full donut beside the pontoon, seen from above", span: "" },
  { src: "/images/real/sailing-ship.jpg", alt: "Traditional sailing ship anchored in the clear waters of Clew Bay", span: "col-span-2" },
  { src: "/images/real/clewbay-drumlins.jpg", alt: "Evening light over the drumlin islands of Clew Bay", span: "" },
  { src: "/images/real/lighthouse.jpg", alt: "Sailboat passing the lighthouse at the mouth of the bay", span: "" },
  { src: "/images/real/rib-jetty.jpg", alt: "Our high-speed RIB moored at the jetty, the Mayo mountains beyond", span: "row-span-2" },
  { src: "/images/real/clewbay-sunset.jpg", alt: "The sun setting behind the mountains across Clew Bay", span: "" },
  { src: "/images/real/island-sunset.jpg", alt: "Guests watching the sun set over Clew Bay from the island", span: "" },
  { src: "/images/real/dji-0026.jpg", alt: "Golden hour over the island coastline as the day ends", span: "col-span-2" },
  { src: "/images/real/clewbay-harbour.jpg", alt: "The sun setting over the moored yachts and islands of Clew Bay", span: "col-span-2" },
  { src: "/images/real/rib-sunset-guests.jpg", alt: "Guests laughing aboard the RIB at sunset, the island flag flying", span: "" },
  { src: "/images/real/clewbay-sailboats.jpg", alt: "Sailboats drifting between the green islands of Clew Bay, seen from the air", span: "col-span-2" },
  { src: "/images/real/sumo-lawn.jpg", alt: "Sumo suit wrestling on the lodge lawn during a group weekend", span: "col-span-2" },
  { src: "/images/real/hen-party-lodge.jpg", alt: "A beach-themed hen party gathered in the lodge dining room", span: "" },
  { src: "/images/real/bunk-room.jpg", alt: "The group bunk room — timber bunks and garden views", span: "" },
];

export const testimonials = [
  { quote: "Private island with the most unbelievable views", name: "Nicole D", source: "Tripadvisor" },
  { quote: "One of the best trips I have ever been on, hands down!!", name: "Mary L", source: "Tripadvisor" },
  { quote: "We were completely blown away by the place.", name: "Niall F", source: "Tripadvisor" },
  { quote: "The accommodation was stunning", name: "Eimear B", source: "Tripadvisor" },
  { quote: "The sea kayaking was so much fun", name: "Clare M", source: "Tripadvisor" },
  { quote: "The island is fabulous, fantastic views and so much to do.", name: "Boycie86", source: "Tripadvisor" },
];

export const contact = {
  eyebrow: "Booking Enquiries",
  heading: "Begin your island story",
  lead: "Tell us about your group and the occasion — we will look after everything else.",
  occasions: [
    "Family Gathering",
    "Birthday Celebration",
    "Hen Party",
    "Stag Party",
    "Corporate Retreat",
    "Wedding",
    "Traitors Island Weekend",
    "Other Occasion",
  ],
};
